import { BaseModel, type RelationConfig } from './base';
import { Employee } from './employee';

// Enums

export enum ExportStatus {
  queued = 0,
  running = 1,
  complete = 2,
  error = 3,
}

export const ExportStatusLabels: Record<ExportStatus, string> = {
  [ExportStatus.queued]: 'general.queued',
  [ExportStatus.running]: 'export.running',
  [ExportStatus.complete]: 'general.complete',
  [ExportStatus.error]: 'general.error',
};

// Main Model

export class ExportModel extends BaseModel {
  idExport!: number;
  created!: number;
  modified!: number;
  typeLabel?: string;
  detailsLabel?: string;
  link?: string | null;
  isParentExport?: boolean;
  employee?: Employee | null;
  children?: ExportModel[];
  type!: string;
  params!: string;
  status!: ExportStatus;
  expiry!: number;
  result!: { count?: number; message?: string } | null;

  static override relations(): RelationConfig {
    return {
      employee: { type: Employee },
      children: { type: ExportModel },
    };
  }

  get isQueued(): boolean {
    return this.status === ExportStatus.queued;
  }

  get isComplete(): boolean {
    return this.status === ExportStatus.complete;
  }

  get isError(): boolean {
    return this.status === ExportStatus.error;
  }

  get isRunning(): boolean {
    return this.status === ExportStatus.running;
  }

  get isExpired(): boolean {
    return this.expiry < (Date.now() / 1000);
  }

  get isInvalid(): boolean {
    return this.result?.count === 0;
  }
}
